import { retrieveLaunchParams, themeParams } from '@tma.js/sdk-react'
import { refreshChromeColors } from './chrome'

/**
 * Платформа клиента — в `data-tg-platform` на <html>: по ней стили выбирают
 * шрифт Telegram (San Francisco, Roboto, Segoe UI), трекинг и полужирный
 * (CLAUDE.md, «Типографика»). Вызывается **до первого рендера**, рядом с темой,
 * иначе текст начнётся с прыжка шрифта.
 *
 * Без launch params (вне Telegram без подмены окружения) атрибута нет —
 * остаётся общий системный стек.
 */
export const applyPlatform = (): void => {
  try {
    const platform = retrieveLaunchParams().tgWebAppPlatform

    if (platform) {
      document.documentElement.dataset.tgPlatform = platform
    }
  } catch {
    // Вне Telegram: шрифт — системный стек браузера.
  }
}

/**
 * Схема клиента — в `data-tg-scheme` на <html>: производных токенов
 * (`segment-bg`, `segment-active`, `skeleton`, `press`) в `themeParams` нет, и
 * стили выбирают их светлый или тёмный вариант по ней. Следит за
 * `themeChanged`; ручная тема (`data-theme`) перебивает схему в стилях.
 */
export const bindColorScheme = (): void => {
  const root = document.documentElement

  const apply = (): void => {
    root.dataset.tgScheme = themeParams.isDark() ? 'dark' : 'light'
    // Новые `--tg-theme-*` SDK пишет в той же смене темы — цвета кнопок берём после них.
    requestAnimationFrame(refreshChromeColors)
  }

  apply()
  themeParams.state.sub(apply)
}
